'use client';

import Footer from '../global/partials/Footer';
import HeaderV2 from '../global/partials/HeaderV2';
import { PageGeneralRulesSchema } from '@/sanity/pages/PageGeneralRulesTemplate';
import HeroSection from '../pageComponents/general-rules/HeroSection';
import RulesSection from '../pageComponents/general-rules/RulesSection';
import ScrollingBanner from '../pageComponents/global/ScrollingBanner';

export default function PageGeneralRulesJSX({
  data,
}: {
  data: PageGeneralRulesSchema;
}) {
  return (
    <main className="flex flex-col items-center">
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType="main"
          language={data.settings?.language}
        />
      )}

      <HeroSection data={data} />
      <RulesSection data={data} />

      <ScrollingBanner
        className="bg-[#f4f5f5] border-y-0"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />

      {data?.settings?.footer && <Footer data={data.settings.footer} finalCta={data} language={data?.settings?.language} />}
    </main>
  );
}
